import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { INotification } from '../../models/notification'
import { logout, refreshSession, selectRelation } from '../actions/constants'

export interface INotificationsState {
  notification: INotification | null
  notifications: INotification[]
  isLoading: boolean
  lastFetchedAt?: number
}

const initialState: INotificationsState = {
  notification: null,
  notifications: [],
  isLoading: false,
  lastFetchedAt: undefined
}

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<INotification | null>) => {
      state.notification = action.payload
    },
    setNotifications: (state, action: PayloadAction<INotification[]>) => {
      state.notifications = action.payload
    },
    deleteNotification: (state, action: PayloadAction<number>) => {
      state.notifications = state.notifications.filter(notification => notification.id !== action.payload)
    },
    updateNotification: (state, action: PayloadAction<INotification>) => {
      state.notifications = state.notifications.map(notification => {
        if (notification.id === action.payload.id) {
          return action.payload
        }

        return notification
      })
    },
    setNotificationsIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setNotificationsLastFetchedAt: (state, action: PayloadAction<number | undefined>) => {
      state.lastFetchedAt = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(selectRelation, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setNotifications,
  deleteNotification,
  updateNotification,
  setNotificationsIsLoading,
  setNotification,
  setNotificationsLastFetchedAt
} = notificationsSlice.actions

export default notificationsSlice.reducer
